import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../../../../lib/utils';

function ProgressBar({ value }) {
  const getProgressColor = () => {
    if (value < 30) return 'bg-red-500';
    if (value < 70) return 'bg-amber-500';
    return 'bg-green-500';
  };

  return (
    <div className="flex items-center gap-2">
      <div className="relative flex-1 h-2 bg-muted rounded-full overflow-hidden min-w-[100px]">
        <div
          className={cn(
            'absolute inset-y-0 left-0 rounded-full transition-all',
            getProgressColor(),
          )}
          style={{ width: `${value}%` }}
        />
      </div>
      <span className="text-sm font-medium text-muted-foreground w-10 text-right">{value}%</span>
    </div>
  );
}

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ProgressBar;
